<template>
  <div v-if="model" class="p-ml-2">
    <LGCardColaborador
      :foto="model.imagem"
      :nome="model.titulo"
      :cargo="model.subtitulo"
      :tamanho-icone="35"
    />
  </div>
</template>

<script>
import LGCardColaborador from 'lg-vue-components/cardColaborador';

export default {
  components: {
    LGCardColaborador,
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
  },
};
</script>
